export default __webpack_public_path__ + "static/media/img-14.332920c9.jpg";